<!-- Actions button bar -->
<div class="action-bar mat-elevation-z2">
	<mat-toolbar>
		@if(!relatedClipsLoading) {
			@if(checkValidity('CREATE_GROUP')) {
			<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Create group" (click)="itemAction('CREATE_GROUP')">
				{{ 'CLIPS.CREATE_GROUP' | translate }}
			</button>
			} @if(checkValidity('MERGE_GROUP')) {
			<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Merge group" (click)="itemAction('MERGE_GROUP')">
				{{ 'CLIPS.MERGE_GROUP' | translate }} ({{ getSelectedItemsCount() }})
			</button>
			}
			<!-- Merge comes first so that with a main selected (where Create group is hidden) the
			     split/unlink button sits second. Create group and Merge are mutually exclusive, so
			     the selection-without-main order stays Create group → Unlink. -->
			@if(checkValidity('UNLINK_FROM_GROUP')) {
			<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Unlink from group" (click)="itemAction('UNLINK_FROM_GROUP')">
				{{ 'CLIPS.UNLINK_FROM_GROUP' | translate }}
			</button>
			} @if(checkValidity('COPY_GROUP')) {
			<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Copy group" (click)="itemAction('COPY_GROUP')">
				{{ 'CLIPS.COPY_GROUP' | translate }}
			</button>
			} @if(checkValidity('GENERATE_REPORT')) {
			<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Generate report" (click)="itemAction('GENERATE_REPORT')">
				{{ 'CLIPS.GENERATE_REPORT' | translate }}
			</button>
			} @if(checkValidity('SEND_TO_CLIENTS')) {
			<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Sent report" (click)="itemAction('SEND_TO_CLIENTS')">
				{{ 'BUTTON.SEND' | translate }}
			</button>
			} @if(checkValidity('COPY_TAGS')) {
	        <button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Copy tags" (click)="itemAction('COPY_TAGS')">
	          {{ 'CLIPS.COPY_TAGS' | translate }}
	        </button>
	        }
	    @if(checkValidity('DELETE_DUPLICATES')) {
			<button mat-raised-button color="warn" class="me-3 x-small-button" aria-label="Delete duplicates item" (click)="itemAction('DELETE_DUPLICATES')">
				{{ 'CLIPS.DELETE_DUPLICATES' | translate }}
			</button>
	  }
	  @if(checkValidity('DELETE')) {
			<button mat-raised-button color="warn" class="me-3 x-small-button" aria-label="Delete item" (click)="itemAction('DELETE')">
				{{ 'BUTTON.DELETE' | translate }}
			</button>
	  }

			@if(checkValidity('ADD_TAGS')) {
			<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Copy group" (click)="itemAction('ADD_TAGS')">
				{{ 'CLIPS.ADD_TAGS' | translate }}
			</button>
			}
		}

    <div class="ms-auto d-flex me-2 align-items-center">
			@if(selectedItems.length && !relatedClipsLoading) {
			<button mat-icon-button color="primary" class="unselect-button me-1"
					matTooltip="{{ 'ASSORTED.UNSELECT_ALL' | translate }}"
					matTooltipPosition="below"
					aria-label="Unselect all"
					(click)="itemAction('UNSELECT_ALL')">
				<mat-icon>close</mat-icon>
			</button>
			}
			@if(selectedItems.length) {
			<span class="info-selected"> {{ 'ASSORTED.SELECTED' | translate }}: {{ selectedItems.length }} \</span>
			}
			<span class="info-selected ms-1">{{ 'ASSORTED.TOTAL' | translate }}: {{ totalItemsCount }}</span>
		</div>

    @if(scrollToTop) {
      <button mat-icon-button color="primary" class="x-small-button" aria-label="Scroll to top" (click)="itemAction('SCROLL_TO_TOP')">
        <mat-icon>arrow_upward_alt</mat-icon>
      </button>
      }
	</mat-toolbar>
	<mat-divider></mat-divider>
</div>
<!-- (END) Actions button bar -->
